<!-- @format -->

<div class="custom-section card">
    <div class="section-header">
        <div>
            <h1 class="section-title">Cloud Storage</h1>
            <span class="subtext">Connect your personal OneDrive accounts to enable automatic file push for form
                submissions.</span>
        </div>
    </div>
    <div class="section-sub-header">
        <div>
            Your One Drive connections
        </div>
        <div>
            <button (click)="this.loginDisplay = true">
                Connect One Drive
            </button>
        </div>
    </div>

    <table class="custom-table">
        <tbody *ngFor="let integration of data">
            <tr>
                <td>
                    <img src="../../assets/one-drive-icon.svg" alt="">
                </td>
                <td>
                    <p class="connection-name">{{integration.integrationName}}</p>
                    <p class="connection-email">{{integration.emailAddress}}</p>
                </td>
                <td>
                    <span class="badge success" *ngIf="integration.connectionStatus">
                        Connected
                    </span>
                    <span class="badge danger" *ngIf="!integration.connectionStatus">
                        Disconnected
                    </span>
                    <button class="btn btn-outline-danger" *ngIf="integration.connectionStatus"
                        (click)="disconnect(integration.cloudIntegrationId, integration.integrationName)">
                        <div class="">
                            <img src="../../assets/x-red-icon.svg" alt="">
                            Disconnect
                        </div>

                    </button>
                </td>
            </tr>
        </tbody>
    </table>
    <div class="empty-container" *ngIf="data.length ===0">
        <div class="empty-cloud-connections">
            <div>
                <div>
                    <img src="../../assets/file-icon.svg" alt="" class="empty-connections-icon">
                </div>
                <div class="empty-connections-header">
                    No connections yet
                </div>
                <div class="empty-connections-sub-heading">
                    Click "Connect OneDrive" to link your Microsoft account.
                </div>
            </div>

        </div>
    </div>
    <app-pagination [values]="values" (pageChange)="onPageChange($event)" *ngIf="totalPages > 0" />
</div>
<app-success-toast *ngIf="toastService.showToast"></app-success-toast>

<app-form-modal *ngIf="this.loginDisplay" (onCancel)="this.loginDisplay=false" title="Connect One Drive"
    subTitle="Give this connection a display name, then you'll be redirected to Microsoft to sign in and grant SmartFlow the required permissions."
    [fields]="modalParams" (onSave)="loginPopup()" actionButtonTitle="Continue to Microsoft" />